import useApiHook from "Hooks/ApiHook";
import { Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import authHeader from "services/auth-header";
import API from "services/axios";

export default function DashboardCustomers() {
  /*   All States
   ********************************************* */
  const user = useSelector((state) => state?.user?.userInfo);

  /*   All Functions
   ********************************************* */

  // const [customersData, setCustomersData] = useState(null);

  const getDashboardCustomers = async () => {
    const response = await API.get("/dashboard/total-customers", {
      headers: authHeader(),
    });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(response.message);
    }
  };

  const {
    data: customersData,
    loading: customersDataLoading,
    error: customersFetchError,
  } = useApiHook(() => {
    return getDashboardCustomers();
  });

  /*   All UseEffects
   ********************************************* */

  return (
    <div
      className="bg-white px-3 py-2 shadow-sm rounded"
      style={{ width: 400 }}
    >
      <div className="d-flex align-items-center justify-content-between">
        <h3 className="fw-bold">Customers</h3>
        {(user?.permissions?.includes("customer_add") ||
          user?.permissions?.includes("customer_update") ||
          user?.permissions?.includes("customer_delete") ||
          user?.roles === "admin") && (
          <Link to="/customer?page=1" className="btn btn-sm btn-success">
            View
          </Link>
        )}
      </div>
      <hr className="mt-0 mb-2" />
      {customersDataLoading || !customersData ? (
        <div className="d-flex justify-content-center align-items-center">
          <Spinner variant="primary" />
        </div>
      ) : customersFetchError ? (
        <div>
          <h4 className="text-danger text-center">Error</h4>
          <p className="text-center">{customersFetchError}</p>
        </div>
      ) : (
        <>
          <div className="row">
            <div className="col-8 fw-bold">Total Customers</div>
            <div className="col-4 text-end">
              {customersData?.totalCustomers || "-"}
            </div>
          </div>
          <div className="row">
            <div className="col-8 fw-bold">With No Location</div>
            <div className="col-4 text-end">
              {customersData?.withoutLocation || "-"}
            </div>
          </div>
          <h4
            className="border-1 mt-3 pe-2 fw-bold border-bottom "
            style={{ width: "fit-content" }}
          >
            By Location
          </h4>
          {customersData &&
            Object.keys(customersData?.byLocation).length &&
            Object.keys(customersData?.byLocation).map((key) => (
              <div className="row">
                <div className="col-8 fw-bold">{key}</div>
                <div className="col-4 text-end">
                  {customersData?.byLocation[key]}
                </div>
              </div>
            ))}
        </>
      )}
    </div>
  );
}
